import React, { useState, useEffect, useRef } from "react";
// import { Col } from "react-bootstrap";
import "../../scss/include/footer.scss";
// import fb from "../../assets/fb.png";
import { BsTwitter, BsInstagram, BsYoutube, BsFacebook } from "react-icons/bs";
import QuickLink from "../customcomponents/quicklink";
import AppBanner from "../customcomponents/appbanner";
import Payment from "../customcomponents/payment";
import fb from "../../assets/facebook.webp";
import twitter from "../../assets/twitter.png";
import instagram from "../../assets/instagram.png";
import youtube from "../../assets/youtube.png";
import { get_company_details, get_home_components, newsletter } from "../../data/api";
// import appbanner from "../../assets/appbanner.png";
import { useNavigate } from "react-router-dom";
import Features from "../customcomponents/features";
import { Formik } from "formik";
import dishhome from "../../assets/dishhome.webp";

import { Button, Form } from "react-bootstrap";
import * as yup from "yup";
import MessageModal from "../customcomponents/messageModal";
import Captcha from "./captcha";
import Widthcontainer from "../customcomponents/widthcontainer";

const Footer = ({ cartupdate, setCartupdate, appBanner, career }) => {
   let navigate = useNavigate();
   const [homeData, setHomeData] = useState("");
   const [contactDetails, setContactDetails] = useState("");

   const [empty, setEmpty] = useState(true);
   useEffect(() => {
      async function fetchData() {
         const response = await get_home_components();
         setHomeData(response.data);
      }
      fetchData();
      async function getCompanyDetails() {
         const response = await get_company_details();
         setContactDetails(response?.data?.data);
      }
      getCompanyDetails();
   }, [empty]);

   useEffect(() => {
      if (homeData === "" || homeData === undefined) {
         setEmpty(true);
      } else {
         setEmpty(false);
      }
   }, [homeData]);

   return (
      <div className="footer-wrapper">
         {appBanner !== "dashain" && appBanner !== "blog" && <Features />}
         {appBanner !== "blog" && <AppBanner data={appBanner} />}
         {appBanner !== "dashain" && appBanner !== "blog" && (
            <QuickLink
               cartupdate={cartupdate}
               setCartupdate={setCartupdate}
               internetPackage={homeData?.internetPackage}
               career={career}
            />
         )}
         {appBanner === "blog" && <BlogFooter />}
         <Payment option={appBanner} contactDetails={contactDetails} />
         <div className="icon-footer">
            <div
               className="footericon-list cursor_pointer"
               onClick={() => {
                  window.open(
                     contactDetails?.facebook || "https://www.facebook.com/dishhome ",
                     "_blank",
                  );
               }}
            >
               <BsFacebook title="Facebook" />
               {/* <img src={fb} alt="Facebook" title="Facebook" /> */}
            </div>
            <div
               className="footericon-list cursor_pointer"
               onClick={() => {
                  window.open(contactDetails?.twitter || "https://twitter.com/dishhome", "_blank");
               }}
            >
               <BsTwitter title="Twitter" />
            </div>
            <div
               className="footericon-list cursor_pointer"
               onClick={() => {
                  window.open(
                     contactDetails?.instagram || "https://www.instagram.com/dishhome.official/",
                     "_blank",
                  );
               }}
            >
               <BsInstagram title="Instagram" />
            </div>
            <div
               className="footericon-list cursor_pointer"
               onClick={() => {
                  window.open(
                     contactDetails?.youtube ||
                     "https://www.youtube.com/channel/UCNKKyb9-Emqvp7efxoY1yjA",
                     "_blank",
                  );
               }}
            >
               <BsYoutube title="Youtube" />
            </div>
         </div>
         <div className="footer ">
            <div
               className="fixed-width75"
               style={{ display: "flex", justifyContent: "space-between" }}
            >
               <div className="first-footer">
                  <li
                     className="footer-text"
                     onClick={() => {
                        navigate("/pages/termsandcondition");
                     }}
                  >
                     Term of Use
                  </li>

                  <li
                     className="footer-text"
                     onClick={() => {
                        // window.open("https://blog.dishhome.com.np/?page_id=3", "_blank");
                        navigate("/privacy-policy");
                     }}
                  >
                     Privacy Policy
                  </li>
                  <li
                     onClick={() => {
                        // window.open("https://blog.dishhome.com.np/?page_id=3", "_blank");
                        navigate("/pages/refundpolicy");
                     }}
                     className="footer-text"
                  >
                     Refund Policy
                  </li>
                  <li
                     onClick={() => {
                        // window.open("https://blog.dishhome.com.np/?page_id=3", "_blank");
                        navigate("/pages/paymentpartners");
                     }}
                     className="footer-text"
                  >
                     Payment Partners{" "}
                  </li>
               </div>
               <div className="icon-footer">
                  <div
                     className="footericon-list cursor_pointer"
                     onClick={() => {
                        window.open(
                           contactDetails?.facebook || "https://www.facebook.com/dishhome ",
                           "_blank",
                        );
                     }}
                  >
                     <img id="footer_social_icon" src={fb} title="Facebook" alt="Facebook" />
                     {/* <BsFacebook /> */}
                  </div>
                  <div
                     className="footericon-list cursor_pointer"
                     onClick={() => {
                        window.open(
                           contactDetails?.twitter || "https://twitter.com/dishhome",
                           "_blank",
                        );
                     }}
                  >
                     {/* <BsTwitter /> */}
                     <img id="footer_social_icon" src={twitter} title="Twitter" alt="Twitter" />
                  </div>
                  <div
                     className="footericon-list cursor_pointer"
                     onClick={() => {
                        window.open("https://www.instagram.com/dishhome_official/", "_blank");
                     }}
                  >
                     <img
                        id="footer_social_icon"
                        src={instagram}
                        title="Instagram"
                        alt="Instagram"
                     />

                     {/* <BsInstagram /> */}
                  </div>
                  <div
                     className="footericon-list cursor_pointer"
                     onClick={() => {
                        window.open(
                           contactDetails?.youtube ||
                           "https://www.youtube.com/channel/UCNKKyb9-Emqvp7efxoY1yjA",
                           "_blank",
                        );
                     }}
                  >
                     <img id="footer_social_icon" src={youtube} alt="Youtube" title="Youtube" />
                     {/* <BsYoutube /> */}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

function BlogFooter() {
   const reRef = useRef();
   const [newsletterSuccess, setNewsletterSuccess] = useState(false);
   const [newsletterError, setNewsletterError] = useState(false);
   const [newsLetterMessage, setNewsLetterMessage] = useState("");
   const handleSubmit = async (values) => {
      const captchaToken = process.env.REACT_APP_ISRECAPTCHA
         === "true" ? await reRef?.current?.executeAsync() : null;
      const response = await newsletter(values.email, captchaToken);
      if (response.status === 201) {
         setNewsletterSuccess(true);
         setNewsLetterMessage(response?.data?.message);
      } else if (response?.response?.status === 409) {
         // console.log("error", response?.response);
         setNewsLetterMessage(response?.response?.data?.message);
         setNewsletterError(true);
      } else {
         // console.log("error", response?.response);

         setNewsLetterMessage(response?.response?.data?.errors[0]?.messages[0]);
         setNewsletterError(true);
      }
   };
   const schema = yup.object().shape({
      email: yup.string().required("Email is required").email("Invalid Email"),
   });
   return (
      <>
         {
            process.env.REACT_APP_ISRECAPTCHA
            === "true" && (
               <Captcha reRef={reRef} />
            )
         }
         <MessageModal
            show={newsletterSuccess}
            setShow={setNewsletterSuccess}
            heading={newsLetterMessage ? "Newsletter Subscribed !" : "Newsletter Subscribed !"}
            message={"Thank You "}
            buttonText={"Ok"}
         />
         <MessageModal
            show={newsletterError}
            setShow={setNewsletterError}
            message={newsLetterMessage}
            buttonText={"Ok"}
            type={"error"}
         />
         <Widthcontainer className={"blog__footer__wrapper"}>
            <div className="blog__footer fixed-width ">
               <div className="d-flex align-items-center blog__image__container">
                  <img src={dishhome} alt="dishhome" style={{ height: "230px", width: "250px" }} />
                  <p className="touch">Lets stay in touch!</p>
               </div>
               <Formik
                  validationSchema={schema}
                  initialValues={{
                     email: "",
                  }}
                  onSubmit={(values, actions) => {
                     handleSubmit(values);
                  }}
               >
                  {({ handleSubmit, handleChange, values, touched, errors }) => (
                     <Form
                        onKeyDown={(e) => {
                           if (e.key === "Enter") {
                              e.preventDefault();
                              handleSubmit();
                           }
                        }}
                        className="blog_newsletter_form"
                     >
                        <div className="d-flex align-items-center w-100">
                           <input
                              // value={email}
                              // onChange={(e) => setEmail(e.target.value)}
                              onChange={handleChange}
                              name="email"
                              value={values?.email}
                              placeholder="Enter your email"
                              type="email"
                              // onKeyPress={(e) => handleKeySubmit(e)}
                              className={errors?.email ? "password_input error" : "Password_input "}
                              style={{
                                 width: "100%",
                                 maxWidth: "390px",
                                 borderRadius: "40px",
                                 border: "1px solid #CCC",
                                 background: "#FFF",
                              }}
                           />
                           {/* {errors?.email ? (
                              <p className="error_message" style={{ color: "#ed1c24" }}>
                                 {errors?.email}
                              </p>
                           ) : null} */}
                           <Button
                              variant="danger"
                              className="mt-0 ms-1 blog_newsletter_btn"
                              onClick={handleSubmit}
                           >
                              Subscribe
                           </Button>
                        </div>
                        <p className="description">
                           Join our newsletter, so that we can reach out to you with our best news
                           and offers!
                        </p>
                     </Form>
                  )}
               </Formik>
            </div>
         </Widthcontainer>
      </>
   );
}

export default Footer;
